import React, {memo} from 'react'
import PropTypes from 'prop-types'

const HbBreadCrumbStructuredData = memo(({type, itemListElement}) => {
  const structuredData = {
    '@context': 'http://schema.org',
    '@type': type,
    itemListElement
  }

  const scriptTag = `<script type="application/ld+json">${JSON.stringify(structuredData)}</script>`

  return <div dangerouslySetInnerHTML={{__html: scriptTag}}></div>;
})

HbBreadCrumbStructuredData.propTypes = {
  type: PropTypes.string,
  itemListElement: PropTypes.array,
}

export default HbBreadCrumbStructuredData
